/**
 * Слот беты для вкладок: модуль беты (`src/beta`) подгружается только в бете и кладёт сюда свои вкладки. Так основная
 * игра не тянет код беты в первую загрузку (бюджет CI).
 */
import type { ComponentType } from "preact";
import type { GameController } from "../game/controller";

export interface BetaTabsSlot {
  /** Вкладка «Герои»: карточки с осколками, замками и ценами. */
  heroes: ComponentType;
  /** Вкладка «Ранг»: звёзды за осколки (пояснение и те же карточки). */
  stars: ComponentType;
  /** Шапка вкладки «Штаб»: ветка «База» со слотами. */
  techHead: ComponentType;
}

let slot: BetaTabsSlot | null = null;

export function setBetaTabs(next: BetaTabsSlot | null): void {
  slot = next;
}

export function getBetaTabs(): BetaTabsSlot | null {
  return slot;
}

/** Бой беты: `connectGame` кладёт сюда контроллер, чтобы бой атаки участка («Карта») шёл на том же экране боя. */
let game: GameController | null = null;

export function setBetaGame(next: GameController | null): void {
  game = next;
}

export function getBetaGame(): GameController | null {
  return game;
}
